"use client";

import { Button, Modal } from "flowbite-react";
import { useState } from "react";
import { useAuth } from "../Management/AuthContext";
import axios from "axios";

export default function ButtonDel({ id, onDeleted }) {
  const [openModal, setOpenModal] = useState(false);
  const { user } = useAuth();
  const [notification, setNotification] = useState({ message: "", type: "" });

  const showNotification = (message, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => {
      setNotification({ message: "", type: "" });
    }, 3000);
  };

  function onCloseModal() {
    setOpenModal(false);
  }

  const deleteCategory = async () => {
    axios.defaults.headers.common["Authorization"] = `Bearer ${user.token}`;
    try {
      const response = await axios.post(
        "https://api-bluerise.bluerise.com.vn/category/delete",
        {
          id: id,
          status: -1,
        }
      );

      if (response.status === 200) {
        onDeleted(id);
        showNotification("Xóa thẻ thành công", "success");
        setOpenModal(false);
      } else {
        showNotification("Xóa thẻ không thành công", "error");
      }
    } catch (error) {
      console.error("Có lỗi xảy ra khi xóa thẻ:", error);
      showNotification("Đã có lỗi xảy ra. Vui lòng thử lại.", "error");
    }
  };

  return (
    <>
      {notification.message && (
        <div
          className={`fixed top-4 right-4 z-50 p-4 text-white ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          } rounded shadow`}
        >
          {notification.message}
        </div>
      )}
      <Button
        className="bg-red-200 text-black border border-black"
        onClick={() => setOpenModal(true)}
      >
        Xóa
      </Button>
      <Modal show={openModal} size="md" onClose={onCloseModal} popup>
        <Modal.Header />
        <Modal.Body>
          <div className="space-y-6">
            <h3 className="text-xl font-medium text-gray-900 dark:text-white text-center">
              Bạn có chắc chắn muốn xóa thẻ?
            </h3>
            <div className="w-full flex items-center justify-center gap-2">
              <Button onClick={deleteCategory}>Xóa</Button>
              <Button onClick={onCloseModal}>Không</Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
